<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">开单打卡&nbsp;/&nbsp;</span>
      </div>
      <div>打卡统计</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header">
            <el-date-picker v-model="query.beginTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="onChange('begin')" :clearable="false"></el-date-picker>
            <span class="plr5">至</span>
            <el-date-picker v-model="query.endTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" @change="onChange('end')" :clearable="false"></el-date-picker>
            <div class="ml10">
              <el-checkbox v-model="query.lookExceptionFlag" @change="doDataSize">只看异常</el-checkbox>
            </div>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名"></el-table-column>
              <el-table-column prop="attendanceDate" label="日期" width="auto" min-width="140px">
                <template slot-scope="scope">
                  <span :class="[(scope.row.beginWorkStatus == 'personalLeave' || scope.row.beginWorkStatus == 'publicLeave') ? 'noSuccess':'']">{{formatDay(scope.row.attendanceDate)}} {{scope.row.week}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="shift" width="auto" label="班次">
                <template slot-scope="scope">
                  <span v-if="scope.row.beginWorkStatus == 'personalLeave' || scope.row.beginWorkStatus == 'publicLeave'">-</span>
                  <span v-else>{{scope.row.shift}}</span>
                </template>
              </el-table-column>
              <el-table-column prop="beginWorkTime" width="auto" label="上班打卡时间" min-width="150px">
                <template slot-scope="scope">
                  {{scope.row.beginWorkTime ? formatDate(scope.row.beginWorkTime): '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="beginWorkStatusCn" width="auto" label="上班打卡结果" min-width="150px">
                <template slot-scope="scope">
                  <span v-if=" scope.row.beginWorkStatus == 'publicLeave'">无需打卡</span>
                  <span class="error" v-else-if="scope.row.beginWorkStatus == 'personalLeave'">{{scope.row.beginWorkStatusCn}}</span>
                  <span :class="[scope.row.beginWorkStatus != 'normal' ? 'error':'']" v-else>{{scope.row.beginWorkStatusCn}} 
                    <span v-if="scope.row.showBeginWaitAuditFlag" class="gorequset">待审核</span>
                    <span v-if="scope.row.showBeginGoProcessFlag" class="gorequset" @click="ToDealWith(scope.row,'begin')">去处理</span>
                  </span>
                </template>
              </el-table-column>
              <el-table-column prop="endWorkTime" width="auto" label="下班打卡时间" min-width="150px">
                <template slot-scope="scope">
                  {{scope.row.endWorkTime ? formatDate(scope.row.endWorkTime): '-'}}
                </template>
              </el-table-column>
              <el-table-column prop="endWorkStatusCn" width="auto" label="下班打卡结果" min-width="150px">
                <template slot-scope="scope">
                  <span v-if="scope.row.endWorkStatus == 'publicLeave'">无需打卡</span>
                  <span v-else-if="scope.row.endWorkStatus == 'personalLeave'" class="error">{{scope.row.beginWorkStatusCn}}</span>
                  <span :class="[scope.row.endWorkStatus != 'normal' ? 'error':'']" v-else>{{scope.row.endWorkStatusCn}} 
                    <span v-if="scope.row.showEndWaitAuditFlag" class="gorequset">待审核</span>
                    <span v-if="scope.row.showEndGoProcessFlag" class="gorequset" @click="ToDealWith(scope.row,'end')">去处理</span>
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataSize"></paging>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="异常处理" :visible.sync="dialogVisible" width="600px" :before-close="cancel">
      <div class="iscompanyQuit" style="margin: 0 0 10px 0;">
        <img
          src="../../../assets/images/new/blueInfo.png"
          alt=""
        />{{ description }}
      </div>
      <el-row class="elRow">
        <el-col :span="12">
          <span>店员姓名：</span>
          <span>{{parmar.staffName}}</span>
        </el-col>
        <el-col :span="12">
          <span>异常类型：</span>
          <span>{{parmar.abnormalTypeCn}}</span>
        </el-col>
        <el-col :span="12" class="mt20">
          <span>打卡时间：</span>
          <span>{{formatDay(parmar.attendanceDate)}}</span>
        </el-col>
        <el-col :span="12" class="mt20">
          <span>打卡类型：</span>
          <span>{{parmar.attendanceTypeCn}}</span>
        </el-col>
        <el-col :span="12" class="mt20">
          <span>打卡状态：</span>
          <span>
            <el-select v-model="parmar.punchStatus" placeholder="请选择" class="w100" @change="skip">
              <el-option v-for="item in option2" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </span>
        </el-col>
      </el-row>
      <div class="dialog-remark">备注</div>
      <el-input v-model="parmar.remark" placeholder="请输备注" type="textarea" maxlength="150"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
export default {
  data() {
    return {
      url: this.$url.attendance.listDay,
      count: this.$url.attendance.count,
      query: {
        beginTime: "",
        endTime: '',
        staffId: '',
        start: 1,
        size: 20,
        lookExceptionFlag: false
      },
      height: this.$store.getters.MainHeight,
      list: [],
      dialogVisible: false,
      parmar: {},
      totalCount: 0,
      description: '',
      option2: [
        {
          value: 'normal',
          label: '正常'
        },
       {
          value: 'no',
          label: '未打卡'
        },
        {
          value: 'personalLeave',
          label: '请假'
        },
        {
          value: 'quit',
          label: '离职'
        }
      ]
    };
  },
  mixins: [minxin],
  components: {},
  computed: {},

  created() {
    let arr  = this.getStartDay(this.$route.query.month);
    this.query.beginTime = arr.monthStartDate;
    this.query.endTime = arr.monthEndDate;
    this.query.staffId = this.$route.query.staffId;
    this.getAttendance();
  },

  methods: {
    details (row) {
      console.log(row);
      let isSuperManage = JSON.parse(localStorage.getItem("shopInfo")).superManage;
      if (isSuperManage && row.auditStatus == "wait") return this.$refs["auditForm"].$emit("set", row);
      this.$refs["detailForm"].$emit("set", row);
    },
    doDataSize (val) {
      if (val.start || val.size) {
				this.query = Object.assign(this.query, val);
			} else {
				this.query = Object.assign(this.query, val);
			}
      this.getAttendance();
    },
    getAttendance () {
      this.$api.post(this.url, this.query).then(res => {
        if (res) this.list = res;
      }).catch(error => {});
      this.$api.post(this.count, this.query).then(res => {
        this.totalCount = res;
      }).catch(error => {});
    },
    getDescriptionFunc () {
      this.description = ''
      this.$api.get(this.$url.attendance.getDescription, {
        staffId: this.parmar.staffId,
        dateMonth: this.formatMonth(this.parmar.attendanceDate)
      }).then(res => {
        if (res) {
          this.description = res;
        }
      }).catch(error => {});
    },
    back() {
      this.$router.push("/dataList/attendanceStatistics");
    },
    ToDealWith (item, type) {
      this.parmar = {
        attendanceDate: item.attendanceDate,
        attendanceType: type == "begin" ? 'work':'offWork',
        attendanceTypeCn: type == "begin" ? '上班卡':'下班卡',
        abnormalType: item.abnormalType ? item.abnormalType : type == "begin" ? item.beginWorkStatus:item.endWorkStatus,
        abnormalTypeCn: item.abnormalType ? item.abnormalTypeCn : type == "begin" ? item.beginWorkStatusCn:item.endWorkStatusCn,
        remark: '',
        id: item.id,
        staffId: item.staffId,
        staffName: item.staffName,
      }
      this.option2 = [
        {
          value: 'normal',
          label: '正常'
        },
       {
          value: 'no',
          label: '未打卡'
        },
        {
          value: 'personalLeave',
          label: '请假'
        },
        {
          value: 'quit',
          label: '离职'
        }
      ]
      this.option2.map((item,index) => {
        if (item.value == (type == "begin" ? item.beginWorkStatus:item.endWorkStatus)) {
          this.option2.splice(index, 1);
        }
      })
      if (type == "begin" && item.beginWorkStatus != 'late') {
        this.option2.unshift({
          value: 'late',
          label: '迟到'
        })
      } else if (type == "end" && item.endWorkStatus != 'leaveEarly') {
        this.option2.unshift({
          value: 'leaveEarly',
          label: '早退'
        })
      }
      this.getDescriptionFunc()
      this.dialogVisible = true;
    },
    submit () {
      this.parmar.attendanceDate = this.formatDay(this.parmar.attendanceDate);
      this.$api.post(this.$url.attendanceApply.apply, this.parmar)
      .then(res => {
        if (res) {
          this.$message.success("操作成功");
          this.dialogVisible = false;
          this.parmar = {};
          this.getAttendance();
        }
      });
    },
    cancel () {
      this.dialogVisible = false;
    },
    onChange (type) {
      if (type == 'begin' && new Date(this.query.beginTime).getTime() > new Date(this.query.endTime).getTime()) {
        return this.$message.error("开始时间不能大于结束时间");
      } else if (type == 'end' && new Date(this.query.beginTime).getTime() > new Date(this.query.endTime).getTime()) {
        return this.$message.error("结束时间不能小于开始时间");
      }
      this.getAttendance();
    },
    skip (value) {
      if (value != 'personalLeave' && value != 'quit') return
      if (this.isSuperManage) { // 店长跳列表转申请  店员跳申请
        if (value == 'personalLeave') {
          let parmar = {
            isSuperManage: this.isSuperManage,
            staffId: this.parmar.staffId,
            attendanceDate: this.parmar.attendanceDate
          }
          this.$router.push("/dataList/companyLeave");
          localStorage.setItem("setCurentUrl", 'dataList/companyLeave');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        } else {
          let parmar = {
            isSuperManage: this.isSuperManage,
            id: this.parmar.staffId,
            source: 'superManage'
          }
          this.$router.push("/manage/companyRecode");
          localStorage.setItem("setCurentUrl", 'manage/companyRecode');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        }
      } else {
        if (value == 'personalLeave') {
          let parmar = {
            isSuperManage: this.isSuperManage,
            staffId: this.parmar.staffId,
            attendanceDate: this.parmar.attendanceDate
          }
          this.$router.push("/dataList/companyLeave");
          localStorage.setItem("setCurentUrl", 'dataList/companyLeave');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        } else {
          let parmar = {
            isSuperManage: this.isSuperManage,
            id: this.parmar.staffId,
            staffName: this.parmar.staffName,
            source: 'superManage'
          }
          this.$router.push("/manage/companyRecode");
          localStorage.setItem("setCurentUrl", 'manage/companyRecode');
          sessionStorage.setItem("attendanceParmas", JSON.stringify(parmar));
        }
      }
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    padding: 16px;
    display: flex;
    align-items: center;
  }
  .plr5 {
    padding: 0 5px;
  }
  .noSuccess {
    color: #62C87F;
  }
  .gorequset {
    padding: 0 5px;
    color: #3388FF;
    border: 1px solid #3388FF;
    border-radius: 2px;
    cursor: pointer;
  }
  .error {
    color: #FF4D4F;
  }
  
}
.w100 {
    width: 130px;
  }
.dialog-remark {
  font-size: 16px;
  margin: 20px 0 10px;
}
.elRow {
  font-size: 16px;
  padding: 20px;
  color: #999;
  background: #FAFAFA;
  border: 1px solid #EEEEEE;
  border-radius: 4px;
}
</style>